import { clsx } from "clsx";
import type { IssuePriority } from "@/features/dev_issues/types";
import { ISSUE_PRIORITY_LABELS } from "@/features/dev_issues/types";

const priorityStyles: Record<IssuePriority, string> = {
  low: "bg-gray-100 text-gray-500 dark:bg-gray-700/50 dark:text-gray-400",
  medium: "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-300",
  high: "bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300",
  critical: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300",
};

interface Props {
  priority: IssuePriority | null;
  className?: string;
}

export function IssuePriorityBadge({ priority, className }: Props) {
  if (!priority) {
    return (
      <span className={clsx("inline-flex items-center px-2 py-0.5 rounded text-xs font-medium text-gray-400 dark:text-gray-500", className)}>
        —
      </span>
    );
  }
  return (
    <span
      className={clsx(
        "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium",
        priorityStyles[priority],
        className
      )}
    >
      {ISSUE_PRIORITY_LABELS[priority]}
    </span>
  );
}
